// extracted by mini-css-extract-plugin
export default {"back-button":"backButton_back-button__Ka7l8"};